// extracted by mini-css-extract-plugin
export default {"host":"TreeNav_host__xQ-OL"};